webpackJsonp([222],{

/***/ 1425:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  head: { "title": "vue-loader 禁用 eslint | VUX - Vue 移动端 UI 组件库", "ignoreSuffixChar": "|" }
});

/***/ }),

/***/ 2379:
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(67)(
  /* script */
  __webpack_require__(1425),
  /* template */
  __webpack_require__(2517),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/data/vux/home/websites/vux-repo/docs/node_modules/v-markdown-loader/_cache/vue-loader-disable-eslint-439.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] vue-loader-disable-eslint-439.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-1a5afa1e", Component.options)
  } else {
    hotAPI.reload("data-v-1a5afa1e", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),

/***/ 2517:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("禁用 eslint")]), _vm._v(" "), _c('p', [_vm._v("并不推荐禁用"), _c('code', [_vm._v("eslint")]), _vm._v(", 编码规范可以一定程序上保证代码质量。但是如果你确实想禁用，可以删除"), _c('code', [_vm._v("build/webpack.base.conf.js")]), _vm._v("里的相关代码。")]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_vm._v("preLoaders: [\n  {\n   "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("test")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-regexp"
  }, [_vm._v("/\\.vue$/")]), _vm._v(",\n   "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("loader")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'eslint'")]), _vm._v(",\n   "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("include")]), _vm._v(": [\n     path.join(projectRoot, "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'src'")]), _vm._v(")\n   ],\n   "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("exclude")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-regexp"
  }, [_vm._v("/node_modules/")]), _vm._v("\n  },\n  {\n   "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("test")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-regexp"
  }, [_vm._v("/\\.js$/")]), _vm._v(",\n   "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("loader")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'eslint'")]), _vm._v(",\n   "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("include")]), _vm._v(": [\n     path.join(projectRoot, "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'src'")]), _vm._v(")\n   ],\n   "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("exclude")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-regexp"
  }, [_vm._v("/node_modules/")]), _vm._v("\n  }\n]\n")])]), _vm._v(" "), _c('p', [_vm._v("如果你只是想禁用对某一文件的检测，那么可以在"), _c('code', [_vm._v(".eslintignore")]), _vm._v("里添加规则。")]), _vm._v(" "), _c('p', [_vm._v("如果你是想禁止某一行的检测，那么可以使用"), _c('code', [_vm._v("// eslint-disable-line")]), _vm._v("。")]), _vm._v(" "), _c('p', [_vm._v("更加灵活的使用参考 "), _c('a', {
    attrs: {
      "href": "http://eslint.org/docs/user-guide/configuring#disabling-rules-with-inline-comments"
    }
  }, [_vm._v("eslint文档")]), _vm._v("。")])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1a5afa1e", module.exports)
  }
}

/***/ }),

/***/ 880:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(2379);

/***/ })

});


// WEBPACK FOOTER //
// 222.c3609107.js